export default "__VITE_ASSET__dac5917f__"